import React from 'react';
import {ProductPrice, useProductOptions} from '@shopify/hydrogen';
import {CurrencyCode as CurrencyCodeType} from '@shopify/hydrogen/storefront-api-types';
import {withCookies} from 'react-cookie';
import clsx from 'clsx';
import * as R from 'ramda';

//types
import type {ProductWithNodes} from '../../types';
import type {Cookies as CookiesType} from 'react-cookie';

//utils
import formatCurrency from '../../utils/formatCurrency.client';

//context
import {GlobalContext} from '../../GlobalProvider.client';

interface BFSProductPrices {
  compare_at_price_max?: number | null;
  compare_at_price_max_hkd?: number | null;
  compare_at_price_max_twd?: number | null;
  compare_at_price_min?: number | null;
  compare_at_price_min_hkd?: number | null;
  compare_at_price_min_twd?: number | null;
  price_max?: number | null;
  price_max_hkd?: number | null;
  price_max_twd?: number | null;
  price_min?: number | null;
  price_min_hkd?: number | null;
  price_min_twd?: number | null;
}

function ProductPrices({
  storefrontProduct,
  cookies,
  type,
}: {
  storefrontProduct: ProductWithNodes & BFSProductPrices;
  cookies: CookiesType;
  type?: string;
}) {
  const {selectedVariant} = useProductOptions();
  const currency = React.useContext(GlobalContext);

  if (!storefrontProduct || !selectedVariant) {
    return null;
  }

  const selectedCurrency =
    (cookies.get('hk-currency') as CurrencyCodeType) ??
    ('HKD' as CurrencyCodeType);

  const selectedCurrencyDetails = currency?.all_currencies?.find(
    (c) => c.currency === selectedCurrency,
  );

  // Product Listing Page
  if (type === 'bfs') {
    const price = storefrontProduct?.price_min;
    const compareAtPrice = storefrontProduct?.price_min;
    return (
      <div className="my-2 flex justify-center text-sm font-bold md:text-md">
        {compareAtPrice ? (
          <span className="mr-1 font-normal text-darkGray line-through decoration-red md:mr-3">
            {selectedCurrencyDetails?.details?.currency?.code}
            {compareAtPrice?.toFixed(2)}
          </span>
        ) : null}
        <span className={clsx('font-normal')}>
          {selectedCurrencyDetails?.details?.currency?.code}
          {price?.toFixed(2)}
        </span>
      </div>
    );
  }

  // Shopify Product
  if (type === 'shopify') {
    const price =
      storefrontProduct?.priceRange?.minVariantPrice?.amount &&
      formatCurrency({
        currencyCode: selectedCurrency,
        amount: storefrontProduct?.priceRange?.minVariantPrice?.amount,
      });
    const compareAtPrice =
      storefrontProduct?.compareAtPriceRange?.minVariantPrice?.amount &&
      formatCurrency({
        currencyCode: selectedCurrency,
        amount: storefrontProduct?.compareAtPriceRange?.minVariantPrice?.amount,
      });
    return (
      <div className="my-2 flex justify-center text-sm font-bold md:text-md">
        {compareAtPrice ? (
          <span className="mr-1 font-normal text-darkGray line-through decoration-red md:mr-3">
            {selectedCurrencyDetails?.details?.currency?.code}
            {compareAtPrice?.toFixed(2)}
          </span>
        ) : null}
        <span className={clsx('font-normal')}>
          {selectedCurrencyDetails?.details?.currency?.code}
          {price && price?.toFixed(2)}
        </span>
      </div>
    );
  }

  // Product Details Page
  if (type === 'details') {
    const price =
      storefrontProduct?.priceRange?.minVariantPrice?.amount &&
      formatCurrency({
        currencyCode: selectedCurrency,
        amount: storefrontProduct?.priceRange?.minVariantPrice?.amount,
      });
    const compareAtPrice =
      storefrontProduct?.compareAtPriceRange?.minVariantPrice?.amount &&
      formatCurrency({
        currencyCode: selectedCurrency,
        amount: storefrontProduct?.compareAtPriceRange?.minVariantPrice?.amount,
      });
    return (
      <div className="flex justify-center font-bold">
        {compareAtPrice ? (
          <span className="mr-3 font-normal text-slate-400 line-through decoration-slate-400">
            {selectedCurrencyDetails?.details?.currency?.code}
            {compareAtPrice?.toFixed(2)}
          </span>
        ) : null}
        <span className={clsx('font-bold text-hk-orange')}>
          {selectedCurrencyDetails?.details?.currency?.code}
          {price && price?.toFixed(2)}
        </span>
      </div>
    );
  }

  // const storefrontProductAdjustedByCurrency = {
  //   ...storefrontProduct,
  //   variants: {
  //     nodes: storefrontProduct.variants.nodes.map((v) => {
  //       const originalCompareAtPrice = v.compareAtPrice?.amount ?? null;
  //       const adjustedCompareAtPrice = originalCompareAtPrice
  //         ? formatCurrency({
  //             currencyCode: selectedCurrency,
  //             amount: originalCompareAtPrice,
  //           })?.toFixed(2)
  //         : '';
  //       const originalPrice = v.price.amount ?? null;
  //       const adjustedPrice = originalPrice
  //         ? formatCurrency({
  //             currencyCode: selectedCurrency,
  //             amount: originalPrice,
  //           })?.toFixed(2)
  //         : '';
  //       const adjustedCurrenyCode: CurrencyCodeType =
  //         selectedCurrency as CurrencyCodeType;
  //       return {
  //         ...v,
  //         compareAtPrice: {
  //           amount: adjustedCompareAtPrice,
  //           currencyCode: adjustedCurrenyCode,
  //         },
  //         compareAtPriceV2: v.compareAtPrice
  //           ? {
  //               amount: adjustedCompareAtPrice,
  //               currencyCode: adjustedCurrenyCode,
  //             }
  //           : null,
  //         price: {
  //           amount: adjustedPrice,
  //           currencyCode: adjustedCurrenyCode,
  //         },
  //         priceV2: {
  //           amount: adjustedPrice,
  //           currencyCode: adjustedCurrenyCode,
  //         },
  //       };
  //     }),
  //   },
  // };

  return (
    <></>
    // <div className="my-2 flex justify-center text-sm font-bold md:text-md">
    //   <ProductPrice
    //     className="mr-1 font-normal text-darkGray line-through decoration-red md:mr-3"
    //     data={storefrontProductAdjustedByCurrency}
    //     priceType="compareAt"
    //     variantId={selectedVariant.id}
    //   />
    //   <ProductPrice
    //     data={storefrontProductAdjustedByCurrency}
    //     variantId={selectedVariant.id}
    //     className="font-normal"
    //   />
    // </div>
  );
}

export default withCookies(ProductPrices);
